import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['wrapper', 'loader', 'backdrop']

  open() {
    this.wrapperTarget.classList.remove('hidden')
    this.backdropTarget.classList.remove('hidden')
    this.loaderTarget.classList.remove('hidden')
  }

  close () {
    this.wrapperTarget.classList.add('hidden')
    this.backdropTarget.classList.add('hidden')
    this.loaderTarget.classList.add('hidden')
  }
}
